export const NAMESPACE = 'visualbuilder';

export const TOGGLE_ELEMENT_INFO = `${NAMESPACE}/toggleElementInfo`;
export const TOGGLE_MENU = `${NAMESPACE}/toggleMenu`;
export const UPDATE_CREATING_BOTSPEC = `${NAMESPACE}/updateCreatingBotspec`;
export const UPDATE_LOADING_BOTSPECS = `${NAMESPACE}/updateLoadingBotspec`;
export const UPDATE_DELETING_BOTSPEC = `${NAMESPACE}/updateDeletingBotspec`;
export const TOGGLE_DELETE_BOTSPEC_MODAL = `${NAMESPACE}/toggleDeleteBotspecModal`;
export const UPDATE_VIEW_BOTSPEC_SETTINGS = `${NAMESPACE}/updateViewBotspecSettings`;
export const UPDATE_VIEW_CONNECTION_PANEL = `${NAMESPACE}/updateViewConnectionPanel`;
export const UPDATE_VIEW_EDITOR_MODAL = `${NAMESPACE}/updateViewEditorModal`;
export const UPDATE_SHOW_EDITOR = `${NAMESPACE}/updateShowEditor`;
export const RESET_VISUALBUILDER = `${NAMESPACE}/resetVisualbuilder`;
export const UPLOADING_FILE_TO_S3 = `${NAMESPACE}/uploadingFileToS3`;
